<template>
  <main class="wrapper-content">
    <h1>{{ $t('invoices') }}</h1>
    <template v-if="!isLoading">
      <b-card class="border">
        <b-row>
          <LmTextInput
            :disabled="!isSuperUser"
            class="col-12 col-md-5"
            label="Nombre"
            v-model="$v.form.invoiceName.$model"
            :v="v('form.invoiceName')"
          />
          <LmDatePicker
            v-if="isSuperUser"
            class="col-12 col-md-4"
            :showComponent="true"
            :showTime="true"
            :config="{
              dateFormat: dateFormat,
              allowInput: true
            }"
            label="Fecha de Emisión"
            v-model="form.issueDate"
          />
          <LmTextInput
            v-else
            disabled
            class="col-12 col-md-4"
            label="Fecha de Emisión"
            v-model="form.issueDate"
          />
          <LmTextInput
            :disabled="!isSuperUser"
            class="col-12 col-md-3"
            label="Número"
            v-model="form.invoiceNumber"
          />
          <LmTreeSelect
            :disabled="!isSuperUser"
            class="col-12 col-md-3"
            label="Moneda"
            pathToGetOptions="/invoices/currencies"
            v-model="$v.form.currency.$model"
            :v="v('form.currency')"
          />
          <LmNumberInputV2
            :disabled="!isSuperUser"
            class="col-12 col-md-4"
            label="Importe Total"
            v-model="$v.form.totalAmount.$model"
            :v="v('form.totalAmount')"
          />
          <LmTreeSelect
            :disabled="!isSuperUser"
            class="col-12 col-md-5"
            label="Estado"
            pathToGetOptions="/invoices/status"
            v-model="$v.form.status.$model"
            :v="v('form.status')"
          />

          <LmUploadFiles
            v-if="isSuperUser"
            label="Subir factura"
            class="col-12"
            duplicateCheck
            v-model="form.files"
            :dropzoneOptions="{
              acceptedFiles: acceptedFormats,
              headers: {
                'Cache-Control': null,
                'X-Requested-With': null
              },
              withCredentials: true,
              thumbnailWidth: 150,
              maxFilesize: 1,
              timeout: 120000,
              addRemoveLinks: true,
              maxFiles: null,
              clickable: true
            }"
          />
          <div v-else class="container">
            <b-row>
              <div v-if="showPaymentButton" id="walletBrick_container" class="col-12 col-md-4"></div>
              <div v-if="showPaymentStatus" id="statusScreenBrick_container" class="col-4"></div>
              <LmFileViewer class="col-12" :class="showPaymentStatus ? 'col-md-8': 'col-md-8'" ref="fileviewer" :files="form.files"/>
            </b-row>
        <!-- <div id="wallet_container"></div> -->
        <!-- https://www.mercadopago.com.ar/developers/es/live-demo/status-screen-brick -->
          </div>
        </b-row>
      </b-card>
      <LmDatatableWithModalSelector
        v-if="isSuperUser"
        datatableSlug="customer-internal-todos"
        datatableModalSlug="customer-internal-todos"
        @itemsAdded="onAddCustomer"
        @itemsToRemove="onRemoveCustomer"
        :hideTableSearcher="true"
        :hideTableFilter="true"
        :hideTableButtons="false"
        :items="form.customer"
        :addItemButtonLabel="$t('add')"
        emptyItemsMessage="No hay un cliente seleccionado"
        removeConfirmationMessage="Estas por quitar el cliente, estas seguro?"
      />

      <div class="buttons">
        <LmButton
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click="onCancel"
          :isProcessing="isProcessing"
        />

        <LmButton
          v-if="isSuperUser"
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isSuperUser && isOnEditMode && !deleted"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_delete')"
          buttonClass="btn-danger"
          :value="$t('delete')"
          @click="onDelete"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isSuperUser && isOnEditMode && deleted"
          value="Reactivar"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_reactivate')"
          buttonClass="btn-success"
          @click="onReactivate()"
          :isProcessing="isProcessing"
        />
      </div>
    </template>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2.vue'
import LmDatePicker from '@/components/form/elements/LmDatePicker'
import LmUploadFiles from '@/components/form/elements/LmUploadFiles'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmDatatableWithModalSelector from '@/components/LmDatatableWithModalSelector'
import LmFileViewer from '@/components/LmFileViewer'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'

import { mapGetters } from 'vuex'
import LmTextInput from '../../components/form/elements/LmTextInput.vue'

export default {
  mixins: [lmToasts],
  components: {
    LmUploadFiles,
    LmDatePicker,
    LmTextInput,
    LmNumberInputV2,
    LmTreeSelect,
    LmDatatableWithModalSelector,
    LmFileViewer,
    LmButton
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    frontendRouteToRedirectAfterCreated: {
      type: String,
      required: true
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('session', ['isSuperUser']),
    lastPaymentId () {
      if (this.form.paymentIds.length) {
        return this.form.paymentIds.slice(-1)[0]
      } else {
        return null
      }
    },
    acceptedFormats () {
      return [
        { id: 1, name: 'PDF' }
      ]
    }
  },
  data () {
    return {
      isLoading: false,
      dateFormat: 'DD-MM-YYYY',
      MercadoPagoPk: process.env?.VUE_APP_MP_PK,
      showPaymentButton: false,
      showPaymentStatus: false,
      form: {
        customer: [],
        issueDate: moment(new Date()).format('DD-MM-YYYY'),
        invoiceName: '',
        invoiceNumber: '',
        currency: {
          id: 'ars'
        },
        status: {
          id: 'pending'
        },
        files: [],
        totalAmount: 0,
        paymentIds: []
      },
      deleted: false,
      isProcessing: true
    }
  },
  validations: {
    form: {
      issueDate: { required },
      invoiceName: { required },
      status: { required },
      currency: { required },
      totalAmount: { required },
      customer: { required }
    }
  },
  methods: {
    async renderWalletBrick () {
      const mp = new window.MercadoPago(this.MercadoPagoPk, {
        locale: 'es-AR'
      })
      const bricksBuilder = mp.bricks()
      const settings = {
        initialization: {
          redirectMode: 'modal'
        },
        customization: {
          texts: {
            action: 'pay',
            valueProp: 'security_safety'
          },
          visual: {
            hideValueProp: false,
            buttonBackground: 'default', // default, black, blue, white
            valuePropColor: 'grey', // grey, white
            buttonHeight: '48px', // min 48px - max free
            borderRadius: '6px',
            verticalPadding: '16px', // min 16px - max free
            horizontalPadding: '0px' // min 0px - max free
          },
          checkout: {
            theme: {
              elementsColor: '#4287F5', // color hex code
              headerColor: '#4287F5' // color hex code
            }
          }
        },
        callbacks: {
          onReady: () => {
            this.isProcessing = false
            /*
              Callback called when Brick is ready.
              Here you can hide loadings from your site, for example.
            */
          },
          onSubmit: async () => {
            const response = await commonsApi.axiosPostWrapper(`/${this.serviceEndpoint}/createPaymentPreference`, {
              invoiceId: this.$route.params.id
            })

            const preference = response.data

            return preference.preferenceId
          }
        }
      }
      window.walletBrickController = await bricksBuilder.create(
        'wallet',
        'walletBrick_container',
        settings
      )
    },

    async renderStatusBrick () {
      const paymentId = this.lastPaymentId
      if (paymentId === null) { return }

      const mp = new window.MercadoPago(this.MercadoPagoPk, {
        locale: 'es-AR'
      })

      const bricksBuilder = mp.bricks()

      const settings = {
        initialization: {
          paymentId: paymentId
        },
        customization: {
          visual: {
            hideStatusDetails: true,
            hideTransactionDate: true,
            style: {
              theme: 'default' // 'default' | 'dark' | 'bootstrap' | 'flat'
            }
          }
        },
        callbacks: {
          onReady: () => {
            this.isProcessing = false
          },
          onError: (error) => {
            console.log(error)
            this.isProcessing = false
          }
        }
      }
      window.statusBrickController = await bricksBuilder.create(
        'statusScreen',
        'statusScreenBrick_container',
        settings
      )
    },
    onAddCustomer (items) {
      if (items?.length) {
        this.form.customer = items.map(i => {
          return {
            id: i.id,
            name: i['customer-name']
          }
        })
      }
    },

    onRemoveCustomer (items) {
      if (items?.length) {
        this.form.customer = []
      }
    },

    v (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSubmit () {
      try {
        await this.validateForm(this.$v)
        this.isProcessing = true
        this.form.issueDate = moment(this.form.issueDate, this.dateFormat).toDate()

        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`, this.form)
        } else {
          const res = await commonsApi.axiosPostWrapper(`/${this.serviceEndpoint}`, this.form)
          this.$router.replace(`${this.frontendRouteToRedirectAfterCreated}${res.data._id}`)
        }
        this.lmToastSuccessMessage(
          `${this.$t('saved_successfully')} '${this.form.invoiceName}'`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosDeleteWrapper(`/${this.serviceEndpoint}/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `${this.$t('was_successfully_deleted')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onReactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/reactivate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('was_successfully_reactivated')}`, `${this.$t('it_was_successfully_reactivated')}`)
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`)
      this.showPaymentButton = res.data?.showPaymentButton
      delete res.data.showPaymentButton
      this.showPaymentStatus = res.data?.showPaymentStatus
      delete res.data.showPaymentStatus
      this.form = res.data
    }
  },
  beforeRouteLeave (to, from, next) {
    if (window.walletBrickController) {
      window.walletBrickController.unmount()
    }
    if (window.statusBrickController) {
      window.statusBrickController.unmount()
    }
    next()
  },
  async created () {
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
        if (!this.isSuperUser) {
          if (this.showPaymentButton) {
            this.renderWalletBrick()
          } else if (this.showPaymentStatus) {
            this.renderStatusBrick()
          }
        } else {
          this.isProcessing = false
        }
      } else {
        this.isProcessing = false
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>
